import React from 'react';
import styled, { keyframes } from 'styled-components';

const draw = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

const StyledSvg = styled.svg`
  width: 40px;
  height: 40px;
  
  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: ${draw} 2s ease-out forwards;
  }
`;

const CriticIcon = () => (
  <StyledSvg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className="path" d="M50 25C35 25 25 35 25 50S35 75 50 75 75 65 75 50 65 25 50 25Z" stroke="#6c757d" strokeWidth="5"/>
    <path className="path" d="M50 50L65 35" stroke="#6c757d" strokeWidth="5" style={{ animationDelay: '0.5s' }}/>
  </StyledSvg>
);

export default CriticIcon;
